import angular from "angular";
import { BeforeunloadService } from "./beforeunload.service";

let module_name = "qpui.bootstrap.beforeunload"
angular.module(module_name, [])

angular.module(module_name, [])
.service({
    qpuiBeforeunload: BeforeunloadService
})

export { module_name }
